'use strict';

class ProductWarehouse {
  constructor(productService, Notification) {
    this.productService = productService;
    this.Notification = Notification;
  }

  $onInit() {
    this.panel = false;
    this.products = [];
    this.productsNotInWarehouse = [];
    this.productsToUpdate = [];

    // sorting
    this.predicate = 'code';
    this.reverse = false;
    this.order = (predicate) => {
      this.reverse = this.predicate === predicate ? !this.reverse : false;
      this.predicate = predicate;
    };

    this.load();
  }

  search() {
    this.panel = true;
  }

  select(number) {
    this.productService.addToWarehouse(number)
      .then(() => {
        this.productsToUpdate = [];
        this.load();
        this.Notification.success('Produktet ble lagt til lagerbeholdningen.');
      })
      .catch((err) => {
        if (err) {
          this.Notification.error('Det har oppstått en feil.');
        }
      });
    this.panel = false;
  }

  load() {
    this.productsToUpdate = [];
    this.productService.listWarehouse()
      .then((resp) => {
        this.products = resp.data.managed;
        this.productsNotInWarehouse = resp.data.unmanaged;
      });
  }

  updateQuantities() {
    let forUpdate = [];
    this.products.forEach((item) => {
      if (this.productsToUpdate.indexOf(item.number) !== -1) {
        forUpdate.push(item);
      }
    });

    this.productService.updateQuantities(forUpdate)
      .then(() => {
        this.productsToUpdate = [];
        this.load();
        this.Notification.success('Antall oppdatert.');
      })
      .catch((err) => {
        if (err) {
          this.Notification.error('Oppdatering mislyktes.');
        }
      });
  }

  productModified(number) {
    if (this.productsToUpdate.indexOf(number) === -1) {
      this.productsToUpdate.push(number);
    }
  }

  removeFromWarehouse(number) {
    swal({
      title: 'Er du sikker?',
      text: 'Produktet ble fjernet fra lagerbeholdningen.',
      type: 'warning',
      confirmButtonColor: '#004b8d',
      confirmButtonText: 'Bekreft',
      showCancelButton: true,
      cancelButtonText: 'Avbryt'
    }, () => {
      this.productService.removeFromWarehouse(number)
        .then(() => {
          this.productsToUpdate = [];
          this.panel = false;
          this.load();
          this.Notification.success('Produktet har blitt fjernet fra lageret.');
        })
        .catch((err) => {
          if (err) {
            this.Notification.error('Det har oppstått en feil.');
          }
        });
      }, this);
  }
}

ProductWarehouse.$inject = ['productService', 'Notification'];

const productWarehouse = {
  controller: ProductWarehouse,
  template: `
    <div class="row">
      <div class="large-6 columns">
        <h2>Lagerbeholdning</h2>
      </div>

      <div class="large-6 columns right-align">
        <a href="#/produkt/nytt" role="button" class="button secondary"><i class="fa fa-plus"></i> Opprett nytt produkt</a>
        <a href="#/produkt" role="button" class="button secondary"><i class="fa fa-list"></i> Produktliste</a>
      </div>
    </div>

    <div class="row">
      <div class="large-6 columns">
        <p class="lead" ng-pluralize count="$ctrl.products.total" when="{'0': 'Ingen produkter', '1': '1 produkt', 'other': '{{ $ctrl.products.total }} produkter'}"></p>
      </div>

      <div class="large-6 columns search-input" ng-show="$ctrl.products.length > 1">
        <i class="fa fa-search"></i>
        <input type="search" ng-model="$ctrl.q" placeholder="Filtrer">
      </div>
    </div>

  <button type="submit" class="button" ng-click="$ctrl.updateQuantities()">Oppdater antall</button>
    <a role="button" class="button secondary" ng-click="$ctrl.search()"><i class="fa fa-plus"></i> Legg til produkt</a>
    <div class="row">
      <div class="large-12 columns">
        <table ng-if="$ctrl.products.length" style="border: solid 1px #004B8D; padding: 1em; max-height: 600px;  display: block; overflow-y: scroll;" >
          <thead>
            <tr>
              <th ng-click="$ctrl.order('code')" ng-class="{ sortorder: $ctrl.predicate === 'code', reverse: $ctrl.reverse }">Produktnummer</th>
              <th>Beskrivelse</th>
              <th class="right-align" ng-click="$ctrl.order('unitPrice')" ng-class="{ sortorder: $ctrl.predicate === 'unitPrice', reverse: $ctrl.reverse }">Utsalgspris</th>
              <th ng-click="$ctrl.order('taxRate')" ng-class="{ sortorder: $ctrl.predicate === 'taxRate', reverse: $ctrl.reverse }">MVA</th>
              <th ng-click="$ctrl.order('quantity')" ng-class="{ sortorder: $ctrl.predicate === 'quantity', reverse: $ctrl.reverse }">Antall</th>
              <th>Fjern <span data-balloon-pos="left" data-balloon="Fjernes kun fra lagerbeholdningen, produktet slettes ikke"><i class="fa fa-question-circle"></i></span></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="product in $ctrl.products | filter:$ctrl.q | orderBy:$ctrl.predicate:$ctrl.reverse track by $index" data-index="{{ $index }}">
              <td>
                <a href="#/produkt/{{ product.number }}">{{ product.code }}</a>
              </td>
              <td>{{ product.description }}</td>
              <td class="right-align">{{ product.unitPrice | crowns }}</td>
              <td>{{ product.taxRate + '%' }}</td>
              <td>
                <input size="10" maxlength="10" width="100" type="number" name="product.quantity" ng-model="product.quantity" ng-change="$ctrl.productModified(product.number)">
              </td>
              <td style="width: 100px" width="100" align="center"><a href ng-click="$ctrl.removeFromWarehouse(product.number)"><i class="fa fa-trash"></i></a></td>
            </tr>
          </tbody>
        </table>
      </div>

      <modal visible="$ctrl.panel">
        <h3 class="subheader">Produkter ({{ filtered.length }} stk)</h3>

        <input type="text" ng-model="q" placeholder="S&oslash;k" autocomplete="off">

        <table class="hovered">
          <thead>
            <tr>
              <th>Produktnr</th>
              <th>Beskrivelse</th>
              <th class="right-align">Enhetpris</th>
              <th class="right-align">MVA</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="item in filtered = ($ctrl.productsNotInWarehouse | orderBy:'code' | filter:{$:q}) track by $index" ng-click="$ctrl.select(item.number)">
              <td>
                <b>{{ item.code }}</b>
              </td>
              <td>{{ item.description }}</td>
              <td class="nowrap right-align">{{ item.unitPrice | crowns }}</td>
              <td class="right-align">{{ item.taxRate }}%</td>
            </tr>
          </tbody>
        </table>
      </modal>
    </div>
  `
};
angular
  .module('SendRegning')
  .component('productWarehouse', productWarehouse)
  .config(($routeProvider) => {
    $routeProvider
      .when('/produkt-lager', {
        title: 'Lagerbeholdning',
        template: '<product-warehouse />',
        secure: true
      });
  });
